export default __webpack_public_path__ + "static/media/redo-24px.fb68544f.svg";